import { classList } from '@findigs/helpers/src/helpers/class-list';
import { Link } from '@findigs/ui-kit/src/components/link';
import { styles } from './footer.module.scss';
import Floop from '~/images/footer-floop.inline.svg';

const findigsLinks: Omit<React.HTMLProps<HTMLAnchorElement>, 'ref' | 'as'>[] = [
  { title: 'About', href: 'https://findigs.com/about/', target: '_blank' },
  { title: 'Careers', href: 'https://findigs.com/careers/', target: '_blank' },
  { title: 'Updates', href: 'https://findigs.com/updates/', target: '_blank' },
];

const termsHref = 'https://www.findigs.com/legal/terms-and-conditions';
const privacyHref = 'https://www.findigs.com/legal/privacy-policy';

export type FooterProps = {
  /**
   * The 'Simple' footer contains less information
   * @default 'Standard'
   */
  variant?: 'Standard' | 'Simple';
};

export const Footer = ({ variant = 'Standard' }: FooterProps) => {
  const classes = classList(styles, variant);
  return (
    <div className={classes}>
      {variant !== 'Simple' ? (
        <Floop
          width="374"
          height="160"
          className="floop"
          aria-label="Findigs Floop"
        />
      ) : null}
      <footer aria-label="Footer">
        {variant !== 'Simple' ? (
          <div className="primary">
            <div>
              <h2>Need help?</h2>
              <Link
                href="mailto:support@findigs.com"
                aria-label="Support e-mail address"
              >
                support@findigs.com
              </Link>
            </div>
            <div>
              <h2>Findigs</h2>
              {findigsLinks.map(({ title, href, ...props }) => (
                <Link key={href} {...props} href={href}>
                  {title}
                </Link>
              ))}
            </div>
          </div>
        ) : null}
        <div className="secondary">
          <div className="links">
            <Link href={termsHref} target="_blank">
              Terms
            </Link>
            <Link href={privacyHref} target="_blank">
              Privacy
            </Link>
            <p>Copyright &copy; {new Date().getFullYear()} Findigs</p>
          </div>
          <p>
            All rights reserved. Various trademarks held by their respective
            owners.
          </p>
        </div>
      </footer>
    </div>
  );
};
